import { Route, Routes, Navigate } from "react-router-dom";
import React from "react";

import RouteAccess from "../utils/RouteAcces";
import { routePaths } from "constants/routePaths";
import withSellerId from "HOCs/withSellerId";
import {Loader} from "../pages";
import {IUserDto} from "../redux/users/types";
import {ISellerData} from "../redux/sellers/types";

interface IRoutesValidate {
  userRegistrationComplete: boolean,
  userAgreementAcceptComplete: boolean,
  isCurrentSellerSetted: boolean,
  currentSeller: ISellerData|null,
  currentUserData: IUserDto|null,
}

function RoutesValidate({ userRegistrationComplete, userAgreementAcceptComplete, isCurrentSellerSetted, currentSeller, currentUserData}: IRoutesValidate) {

  //
  const deniedRoutesGroup1 = [
    "/settings", "/stocks-fbs", "/:id/stocks-fbs", "/stocks-fbo", "/:id/stocks-fbo", "/stocks-export",
    "/:id/stocks-export", "/stocks-reserve", "/:id/stocks-reserve", "/:id/warehouse", "/:id/warehouses",
    "/warehouse", "/warehouses", "/tools", "/:id/tools", "/tools/barcode", "/:id/tools/barcode",
    "/seller/edit/:sellerId", "/:id/seller/edit/:sellerId"
  ]
  const deniedRoutesOfSellerByEmail = {
    'silecode.mp@silecode.ru': {
      18152: deniedRoutesGroup1,
    },
    'silecode.mp2@silecode.ru': {
      18152: deniedRoutesGroup1,
    },
  };

  let denyRulesBySeller: string[] = [];
  const userEmail = currentUserData?.email || null
  if (userEmail) {
    // @ts-ignore
    const rulesByEmail = deniedRoutesOfSellerByEmail[userEmail] || null
    if (currentSeller?.id && rulesByEmail) {
      denyRulesBySeller = rulesByEmail[currentSeller.id] || null
    }
  }

  //
  if (!userRegistrationComplete) {
    return <Navigate to="/welcome" />
  } else if (userRegistrationComplete && !userAgreementAcceptComplete) {
    return isCurrentSellerSetted ? <Navigate to="/welcome/service-agreement" /> : <Loader />
  } else if (userRegistrationComplete && userAgreementAcceptComplete ) {
    return (
        isCurrentSellerSetted ? <Routes>
        {
          routePaths &&
          routePaths.map(({path, element, roles, needSellerId}) => {
            if(denyRulesBySeller && denyRulesBySeller.includes(path)) {
              return (
                  <Route
                      key={path}
                      path={path}
                      element={<Navigate to="/" />}
                  />
              )
            }
            return (
              <Route
                key={path}
                path={path}
                element={needSellerId ? RouteAccess(withSellerId(element), roles) : RouteAccess(element, roles)}
              />
            )
          })
        }
      </Routes> : <Loader />
    )
  } else {
    return <div>Что-то пошло не так. Напишите пожалуйста нам в поддержку</div>
  }
}

export default React.memo(RoutesValidate);
